import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import PropTypes from 'prop-types';
import React, { memo, useCallback, useState } from 'react';
import metadata from './TimelineDropdown.metadata.json5';
import styles from './TimelineDropdown.module.scss';

const TimelineDropdown = memo(props => {
    const { options, onValueChange } = props;
    const uniqueOptions = [
        ...new Map(options.map(option => [option['code'], option])).values(),
    ];
    const [selectedOption, setSelectedOption] = useState(undefined);

    const handleValueChange = useCallback(
        (selectedItem = 'all') => {
            setSelectedOption(selectedItem);
            onValueChange({
                code: selectedItem,
            });
        },
        [onValueChange]
    );

    const overrideProps = {
        timelineDropdown: {
            availableValues: uniqueOptions,
            value: selectedOption,
        },
    };
    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            handleValueChange: handleValueChange,
        },
    };

    const readValue = useCallback(
        (id, path) => {
            return readViewModelValue(
                metadata.componentContent,
                props,
                id,
                path,
                overrideProps
            );
        },
        [props, overrideProps]
    );
    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            model={props}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            resolveValue={readValue}
        />
    );
});

TimelineDropdown.propTypes = {
    options: PropTypes.shape([]).isRequired,
    onValueChange: PropTypes.func.isRequired,
};

export default TimelineDropdown;
